import axios from 'axios'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_PATH + '/',
  timeout: 15000,
  withCredentials: true,
})

// Intercept Request
api.interceptors.request.use(
  config => {
    //config.headers['Authorization'] = 'Bearer ' + getToken()
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// Intercept Error Response
api.interceptors.response.use(
  response => {
    return response
  },
  function (error) {
    if (error.response.status === 401) {
      window.location.href = '/v-login'
    }
    return Promise.reject(error)
  }
)

//const getToken = () => localStorage.getItem('token')

export default api
